import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BusinessFinderService } from './business-finder.service';
import { FlightSchoolResult } from '../models/flight-school-result.model';
import { LatLon } from '../../util/geodesy/latlon';
import { BoundingBox } from '../../util/geodesy/bounding-box';

/**
 * HTTP service for the Flight School Finder. Calls the AirportsAPI `~/flight-schools` endpoint. Category
 * facet filtering (Training Type / Certifications / Ratings / Advanced / Services / ...) is applied
 * client-side in {@link SearchPageComponent}; this service performs only the location/state/keyword query.
 */
@Injectable({
  providedIn: 'root'
})
export class FlightSchoolsService extends BusinessFinderService<FlightSchoolResult> {

  protected readonly endpoint = 'flight-schools';

  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  protected parse(data: any): FlightSchoolResult {
    return FlightSchoolResult.parse(data);
  }

  getFlightSchoolsByLatLon(latlon: LatLon, radius: number): Promise<FlightSchoolResult[]> {
    return this.getByLatLon(latlon, radius);
  }

  getFlightSchoolsByBoundingBox(bounds: BoundingBox): Promise<FlightSchoolResult[]> {
    return this.getByBoundingBox(bounds);
  }

  getFlightSchoolsByState(state: string): Promise<FlightSchoolResult[]> {
    return this.getByState(state);
  }

  getFlightSchoolsBySearchTerm(term: string): Promise<FlightSchoolResult[]> {
    return this.getBySearchTerm(term);
  }
}
